<template>
  <div>
    購物車
  </div>
</template>

<script>
export default {};
</script>

<style></style>
